import { useEffect, useRef } from "react";

const useScrollRestoration = (trigger: boolean, scrollableElementId: string) => {

  const scrollableElement = document.getElementById(scrollableElementId);

  const scrollPosition = localStorage.getItem('scrollPosition') ? Number(localStorage.getItem('scrollPosition')) : 0;

  // Сохраняем положение скролла перед действием, которое перерисовывает компонент
  const saveScrollPosition = () => {      
      if (scrollableElement) {
          localStorage.setItem('scrollPosition', String(scrollableElement.scrollTop));
        }
  };

  // Восстанавливаем положение скролла после перерисовки
  useEffect(() => {
    if (trigger && scrollableElement) {
        scrollableElement.scrollTo(0, scrollPosition);
    }
  }, [trigger]);

  return saveScrollPosition;
};

export default useScrollRestoration;
